import { styles } from '@app/services/app-styles.service';

const datatable = {
    headerCell: {
        padding: styles().paddingXs,
        color: styles().textColorSoft,
    },
    bodyCell: {
        padding: styles().paddingXs,
    },
    rowStriped: {
        background: styles().layerSecondary,
    },
    columnTitle: {
        fontWeight: styles().fontWeight,
    },
};

export default datatable;
